import api from 'lib/trpcClient';

const useEqualisations = (vehicleId?: string) => {
  const { data: equalisations } = api.equalisations.list.useQuery(
    {
      vehicleId: vehicleId ?? '',
    },
    {
      enabled: !!vehicleId,
    },
  );

  const hasEqualisationInDraftState = equalisations?.results?.some(
    (equalisation) => equalisation.isDraft,
  );

  const latestApprovedEqualisationDate =
    equalisations?.latestApprovedEqualisationDate?.toLocalDate();

  return {
    hasEqualisationInDraftState,
    latestApprovedEqualisationDate,
  };
};

export default useEqualisations;
